import MapView = require("esri/views/MapView");
import ToolBar from "../Toolbar";
import ToolButton from "./toolButton";

// ViewInGoogleTool

export default class ViewInGoogleTool extends ToolButton {
  private eventHandler: IHandle;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
  }

  deactivateTool() {
    // console.log("measureDistanceTool deactivateTool")
    if (this.eventHandler) {
      this.eventHandler.remove();
    }
    document.body.style.cursor = "default";
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("ViewInGoogleTool start")
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        this.view.focus();
        document.body.style.cursor = "crosshair";

        this.eventHandler = this.view.on("click", mouseEvent => {
          // https://www.google.com/maps/place/49.46800006494457,17.11514008755796/@49.46800006494457,17.11514008755796,17z
          const url =
            "https://www.google.com/maps/place/" +
            mouseEvent.mapPoint.latitude +
            "," +
            mouseEvent.mapPoint.longitude +
            "/@" +
            mouseEvent.mapPoint.latitude +
            "," +
            mouseEvent.mapPoint.longitude +
            ",17z";
          window.open(url);
          mouseEvent.stopPropagation();
          this.toolbar.setPanAsActiveTool();
        });
      }
    } catch (error) {
      console.error("Error: in ViewInGoogleTool " + +error.message);
    }
  }
}
